import axiosInstance from "../../app/apiClient";
import { QuestionsAdminService } from "../model/question";


const getQuestionsData = (content?: any, status?: any, type?: any) => axiosInstance.get(`api/v1/questions?content=${content}&status=${status}&type=${type}`);
const addQuestions = (data: any) => axiosInstance.post(`api/v1/questions`, data);
const updateQuestions = ( id: number,data: any) => axiosInstance.put(`api/v1/questions/${id}`, data)
const removeQuestions = (id: number) => axiosInstance.delete(`api/v1/questions/${id}`)
const getOneQuestions = (id: number) => axiosInstance.get(`api/v1/questions/${id}`)
const answerQuestions = (data: any) => axiosInstance.post(`/api/v1/questions/answer`, data);
const questionsAdmin: QuestionsAdminService = {
    getQuestionsData,
    addQuestions,
    updateQuestions,
    removeQuestions,
    getOneQuestions,
    answerQuestions
}
export default questionsAdmin;